import { useState, useEffect } from 'react';
import { EXPLORER } from '../../constants';

//UTILS
import AdminService from '../../services/admin_services';
import TokenService from '../../services/token_services';
import { useParams, useNavigate } from 'react-router';

//COMPONENTS
import Menu from '../../components/menu/admin';
import BoardHeader from '../../components/boardheader/admin';

//MEDIA
import POLYGON from '../../assets/images/polygon-matic-logo.png';
import LOGO_BLACK from '../../assets/images/logo_black.png';
import TOKEN_BLACK from '../../assets/images/token_black.png';
import LOGO from '../../assets/images/logo.png';

//TRANSLATION
import { useTranslation } from 'react-i18next';
import Button from '../../components/button';

const AdminUser = () => {
    const { t } = useTranslation();
    const navigate = useNavigate();
    const [profile, setProfile] = useState({});
    const [balance, setBalance] = useState("-")
    const [caam, setCaam] = useState("-")
    const { user_uuid } = useParams();

    useEffect(() => {
        // Prevent page caching
        window.history.pushState(null, null, window.location.pathname);
        window.addEventListener('popstate', handleBackButton);
        
        // Check authentication
        if (!TokenService.isUser()) {
            navigate('/admin/signin', { replace: true });
            return;
        }
        
        loadUser()
        
        return () => {
            window.removeEventListener('popstate', handleBackButton);
        };
        // eslint-disable-next-line
    }, []);

    const handleBackButton = () => {
        if (!TokenService.isUser()) {
            navigate('/admin/signin', { replace: true });
        } else {
            window.history.pushState(null, null, window.location.pathname);
        }
    };

    const loadUser = async () => {
        const data = await AdminService.getUser(user_uuid);
        let tokens = {};
        for (let token of data.wallet.tokens) {
            tokens[token.metadata.symbol] = token;
        }
        setBalance(tokens["CaaEURO"].balance);
        setCaam(tokens["CAAM"].balance);
        setProfile(data);
    }

    const resetKYC = async () => {
        const data = await AdminService.resetKYC(user_uuid);
        console.log(data)
        loadUser()
    }

    return (
        <div className="dashboard">
            <Menu />
            <div className="right_board">
                <BoardHeader title={profile.firstname ? `${profile.firstname} ${profile.lastname}` : t('admin.lifise_users')} />
                {profile && profile.public_address && <div className="content">
                    <div className="big_avatar"
                        style={{
                            backgroundImage: profile.selfie ? `url('data:image/${profile.selfie_ext};base64,${profile.selfie}')` :
                                `url('https://api.dicebear.com/7.x/initials/svg?seed=${profile.public_address}')`
                        }}>
                    </div>
                    <div className="mt-10">
                        <h2>{profile.firstname} {profile.lastname}</h2>
                    </div>
                    <p>{t('admin.profile.kyc_status')}: <strong>{profile.kyc_status ? profile.kyc_status : t('dashboard.no_kyc')}</strong></p>
                    <Button title={t('admin.reset_kyc')} click={resetKYC} />
                    <div className='slash'></div>
                    <p>{t('admin.profile.email')}: <strong>{profile.email_address}</strong></p>
                    <p>{t('admin.profile.phone')}: <strong>{profile.phone}</strong></p>
                    <p>{t('admin.profile.address')}: <strong>{profile.public_address}</strong></p>
                    <p>{t('admin.profile.birthdate')}: <strong>{profile.birthdate ? new Date(profile.birthdate).toLocaleDateString() : '-'}</strong></p>
                    <h3>
                        <small>{t('admin.profile.matic')}:</small> <strong>{profile.wallet && parseFloat(profile.wallet.matic).toFixed(2)}</strong> <img src={POLYGON} className="matic_logo" alt="Logo Matic Polygon" />
                    </h3>
                    <h2>
                        <small>{t('admin.profile.caaeuro')}:</small> <strong>{balance}</strong> <img src={LOGO_BLACK} className="balance_logo" alt="Logo CaaEuro" />
                    </h2>
                    <h2>
                        <small>{t('admin.profile.caam')}:</small> <strong>{caam}</strong> <img src={TOKEN_BLACK} className="balance_logo" alt="Logo CaaM" />
                    </h2>
                    {profile.token_claims && profile.token_claims.to_claim.length > 0 && <p className="mt-30"><strong>{t('admin.profile.pending')}</strong></p>}
                    {profile.token_claims && profile.token_claims.to_claim.map(op =>
                        <div className="operation" key={op.token_claim_uuid}>
                            <div className="op_type">{t('admin.pending')} </div>
                            <div className="op_link" onClick={() => window.open(`${EXPLORER}/tx/${op.tx_hash}`)}>{op.tx_hash}</div>
                            <div className="op_date">
                                {t('admin.profile.created_date')} {new Date(op.created_date).toLocaleDateString()} {new Date(op.created_date).toLocaleTimeString()}
                            </div>
                            <div className="select">
                                <div className="select_profile">
                                    <div className="select_avatar" style={{ backgroundImage: `url('${LOGO_BLACK}')` }}></div>
                                    <div className="select_info">
                                        <span className="select_name">
                                            Lifise
                                        </span>
                                        <span className="select_email">
                                            {t('admin.profile.awaiting')}
                                        </span>
                                    </div>
                                </div>
                            </div>
                            <div className="tx_value">+ {op.nb_token}</div>
                            <img className="tx_symbol" alt="CaâEuro symbol" src={LOGO} />
                        </div>
                    )}
                    {profile.token_claims && profile.token_claims.already_claimed.length > 0 && <p className="mt-30"><strong>{t('admin.profile.already_claimed')}</strong></p>}
                    {profile.token_claims && profile.token_claims.already_claimed.map(op =>
                        <div className="operation" key={op.token_claim_uuid}>
                            <div className="op_type">{t('admin.claimed')} </div>
                            <div className="op_link" onClick={() => window.open(`${EXPLORER}/tx/${op.tx_hash}`)}>{op.tx_hash}</div>
                            <div className="op_date">
                                {t('admin.profile.created_date')} {new Date(op.created_date).toLocaleDateString()} {new Date(op.created_date).toLocaleTimeString()}
                            </div>
                            <div className="select">
                                <div className="select_profile">
                                    <div className="select_avatar" style={{ backgroundImage: `url('${LOGO_BLACK}')` }}></div>
                                    <div className="select_info">
                                        <span className="select_name">
                                            Lifise
                                        </span>
                                        <span className="select_email">
                                            {t('admin.profile.claimed_date')} {new Date(op.claimed_date).toLocaleDateString()} {new Date(op.claimed_date).toLocaleTimeString()}
                                        </span>
                                    </div>
                                </div>
                            </div>
                            <div className="tx_value black">+ {op.nb_token}</div>
                            <img className="tx_symbol" alt="CaâEuro symbol" src={LOGO_BLACK} />
                        </div>
                    )}
                </div>}
            </div>
        </div>
    )
};

export default AdminUser;